// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Axios from 'axios'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'

import VueI18n from 'vue-i18n'
Vue.use(VueI18n);

Vue.use(Vant);

Vue.config.productionTip = false;
Vue.config.devtools = true;
if (process.env.NODE_ENV == 'development') {
  Vue.prototype.$build = '/build';
} else {
  // Vue.prototype.$build = `${window.location.protocol}//www.bunchparty.com/menub`;
  // Vue.prototype.$build = 'http://47.56.146.107/menub'; //新服务器
  // Vue.prototype.$build = 'http://8.210.169.110/menub'; //新服务器
  Vue.prototype.$build = 'https://www.fastpoint.online'; // 新的正式服务器
}

Vue.prototype.$axios = Axios;
Vue.prototype.sessionStorage = sessionStorage;
Vue.prototype.localStorage = localStorage;

//多语言
const i18n = new VueI18n({
  locale: sessionStorage.getItem('locale') || 'en',
  messages: {
    'zh': require('./assets/common/lang/zh'), // 中文语言包
    'en': require('./assets/common/lang/en'), // 英文语言包
    'hk': require('./assets/common/lang/hk') //中文繁体
  },
})


new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
// new Vue({
//     el: '#app',
//     router,
//     components: { App },
//     template: '<App/>'
// });
// 



// WEBPACK FOOTER //
// ./src/main.js